export const BASE_URL = "https://stage.acaemployerform.com/qleaca/api";

export const COMMON_CONFIG = "COMMON_CONFIG";

export const PHONE = /^[0-9\- ]{10}$/;
export const ZIPCODE = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const EINNUMBER = /(^\d{9})|(^\d{3}-\d{2}-\d{4}$)|(^[1-9]\d?-\d{7}$)/;

//export const PHONECOUNTRYCODE = /((00)?(\+)?\d{1,3})[-\s]+(\d{1,3})[-\s]+(\d{4,10})/
//export const PHONECOUNTRYCODE = /^\+(?:[0-9] ?){6,14}[0-9]$/;
export const PHONECOUNTRYCODE =
  /^(\+\d{1,2}\s?)1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export enum loginTypes {
  FETCH_LOGIN_REQUEST = "FETCH_LOGIN_REQUEST",
  FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS",
  FETCH_LOGIN_FAILURE = "FETCH_LOGIN_FAILURE",
  LOGGED_INFO = "LOGGED_INFO",
}

export enum otpTypes {
  FETCH_OTP_REQUEST = "FETCH_OTP_REQUEST",
  FETCH_OTP_SUCCESS = "FETCH_OTP_SUCCESS",
  FETCH_OTP_FAILURE = "FETCH_OTP_FAILURE",
  OTP_INFO = "OTP_INFO",
}

export enum homeTypes {
  FETCH_HOME_REQUEST = "FETCH_HOME_REQUEST",
  FETCH_HOME_SUCCESS = "FETCH_HOME_SUCCESS",
  FETCH_HOME_FAILURE = "FETCH_HOME_FAILURE",
  HOME_INFO = "HOME_INFO",
}

export enum faqTypes {
  FETCH_FAQ_REQUEST = "FETCH_FAQ_REQUEST",
  FETCH_FAQ_SUCCESS = "FETCH_FAQ_SUCCESS",
  FETCH_FAQ_FAILURE = "FETCH_FAQ_FAILURE",
  FAQ_INFO = "FAQ_INFO",
}

export enum employerTypes {
  FETCH_EMPLOYER_REQUEST = "FETCH_EMPLOYER_REQUEST",
  FETCH_EMPLOYER_SUCCESS = "FETCH_EMPLOYER_SUCCESS",
  FETCH_EMPLOYER_FAILURE = "FETCH_EMPLOYER_FAILURE",
  EMPLOYER_INFO = "EMPLOYER_INFO",
}

export enum statesTypes {
  FETCH_STATES_REQUEST = "FETCH_STATES_REQUEST",
  FETCH_STATES_SUCCESS = "FETCH_STATES_SUCCESS",
  FETCH_STATES_FAILURE = "FETCH_STATES_FAILURE",
  STATES_INFO = "STATES_INFO",
}

export enum addACATypes {
  FETCH_ACA_REQUEST = "FETCH_ACA_REQUEST",
  FETCH_ACA_SUCCESS = "FETCH_ACA_SUCCESS",
  FETCH_ACA_FAILURE = "FETCH_ACA_FAILURE",
  ACA_INFO = "ACA_INFO",
}

export enum privacyTypes {
  FETCH_PRIVACY_REQUEST = "FETCH_PRIVACY_REQUEST",
  FETCH_PRIVACY_SUCCESS = "FETCH_PRIVACY_SUCCESS",
  FETCH_PRIVACY_FAILURE = "FETCH_PRIVACY_FAILURE",
  PRIVACY_INFO = "PRIVACY_INFO",
}

export enum resendOTPTypes {
  FETCH_RESEND_OTP_REQUEST = "FETCH_RESEND_OTP_REQUEST",
  FETCH_RESEND_OTP_SUCCESS = "FETCH_RESEND_OTP_SUCCESS",
  FETCH_RESEND_OTP_FAILURE = "FETCH_RESEND_OTP_FAILURE",
  RESEND_OTP_INFO = "RESEND_OTP_INFO",
}

export enum slugTypes {
  FETCH_SLUG_REQUEST = "FETCH_SLUG_REQUEST",
  FETCH_SLUG_SUCCESS = "FETCH_SLUG_SUCCESS",
  FETCH_SLUG_FAILURE = "FETCH_SLUG_FAILURE",
  SLUG_INFO = "SLUG_INFO",
}

//GET UPLOAD LOGO


export enum getUploadLogoTypes {
  FETCH_GET_UPLOADLOGO_REQUEST = "FETCH_GET_UPLOADLOGO_REQUEST",
  FETCH_GET_UPLOADLOGO_SUCCESS = "FETCH_GET_UPLOADLOGO_SUCCESS",
  FETCH_GET_UPLOADLOGO_FAILURE = "FETCH_GET_UPLOADLOGO_FAILURE",
  GET_UPLOADLOGO_INFO = "GET_UPLOADLOGO_INFO",
}
// get Recaptcha 

export enum getRecaptchaTypes {
  FETCH_GET_RECAPTCHA_REQUEST = "FETCH_GET_RECAPTCHA_REQUEST",
  FETCH_GET_RECAPTCHA_SUCCESS = "FETCH_GET_RECAPTCHA_SUCCESS",
  FETCH_GET_RECAPTCHA_FAILURE = "FETCH_GET_RECAPTCHA_FAILURE",
  GET_RECAPTCHA_INFO = "GET_RECAPTCHA_INFO",
}